import { View } from 'react-native'
import { AccountAdminScreen } from '../../src/accounts/components/AccountAdminScreen/AccountAdminScreen'
import { useAccountAdminDrawerShift } from '../../src/accounts/contexts/AccountAdminDrawerShiftContext'
import { getWebAccountAdminDrawerPushStyle } from '../../src/accounts/helpers/accountAdminDrawerPushWeb.helper'
import { useAccountAdminSiteMenuLinks } from '../../src/accounts/hooks/useAccountAdminSiteMenuLinks'

function AccountAdminInAppRouteBody() {
  const siteMenuLinks = useAccountAdminSiteMenuLinks()
  const { shiftPx } = useAccountAdminDrawerShift()
  return (
    <View style={[{ flex: 1 }, getWebAccountAdminDrawerPushStyle(shiftPx)]}>
      <AccountAdminScreen siteMenuLinks={siteMenuLinks} />
    </View>
  )
}

export default function AccountAdminRoute() {
  return <AccountAdminInAppRouteBody />
}
